import {Component, OnInit} from "@angular/core";
import {TeTemplateObjectBaseComponent} from "../te-template-object-base.component";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";

@Component(
    {
    selector: "te-template-object-full",
    templateUrl: "./te-template-object-full.component.html",
    styleUrls: ["./te-template-object-full.component.scss"],
    standalone: false
}
)

export class TeTemplateObjectFullComponent extends TeTemplateObjectBaseComponent implements OnInit {

    // Merged navigation: only 2 top-level items (Editor + Test & Vorschau)
    // Sub-tabs (Variablen, Artefakte, Basisdaten, Selected Case) live inside the left panel via p-tabs
    navigationItems: NavigationItem[] = [
        { label: 'Editor', action: 'Editor', icon: 'fa-regular fa-pen-to-square', default: true, toggleable: false },
        { label: 'Test & Vorschau', action: 'Testen', icon: 'fa-regular fa-flask-vial', toggleable: false },
    ];

    isIframeFullView: boolean = false;
    isSplitterResizing: boolean = false;

    ngOnInit() {
        super.ngOnInit();
    }

    toggleIframeFullView() {
        this.isIframeFullView = !this.isIframeFullView;
    }

    onSplitterResizeStart() {
        this.isSplitterResizing = true;
    }

    onSplitterResizeEnd() {
        this.isSplitterResizing = false;
    }
}
